import { createIconSet } from "react-native-vector-icons";
import typo from "./typo.json";

let typoGlyphMap = {};
Array.from(typo.glyphs).forEach(g => {
    typoGlyphMap[g.name] = g.unicode_decimal;
})

const iconSet = createIconSet(typoGlyphMap, "typo", "Typo.ttf");

export default iconSet;
